import { Component } from "react";
import { MentionSuggestion } from "../../mentions";
import PropTypes from "prop-types";

export default class PromiseProvider extends Component {
  static propTypes = {
    promise: PropTypes.oneOfType([PropTypes.instanceOf(Promise), PropTypes.func]).isRequired,
    query: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { query } = this.props;
    this.emitSuggestions(query);
  }

  shouldComponentUpdate = nextProps => this.props.query !== nextProps.query;

  componentDidUpdate() {
    const { query } = this.props;
    this.emitSuggestions(query);
  }

  emitSuggestions = query => {
    const { promise: promiseOrCreate, onChange } = this.props;

    const promise = promiseOrCreate instanceof Promise ? promiseOrCreate : promiseOrCreate(query);

    if (promise instanceof Promise) {
      promise.then(
        potentialSuggestions => {
          const nextSuggestions = potentialSuggestions.filter(
            maybeSuggestion => maybeSuggestion instanceof MentionSuggestion,
          );

          onChange(nextSuggestions);
        },
        () => onChange([]),
      );
    }
  };

  render = () => null;
}
